import { AddIncidentExpenseFormModalContext } from '@/contexts'
import { useContext } from 'react'

export const useAddIncidentExpenseFormModalContext = () => {
  const context = useContext(AddIncidentExpenseFormModalContext)

  if (!context) throw new Error('useAddIncidentExpenseFormModalContext has to be wrapped AddIncidentExpenseFormModalContextProvider')
  
  return context
}
